module.exports = __webpack_public_path__ + "img/calligraphy-tiao-icon2.183e8a13.jpg";